export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/it.lyaml"));
at({ "it": { "public": { "sampleString": "Stringa di esempio" } } });
};